import { useState, useEffect } from "react";
import { api } from "../api/client";
import { Spinner, FormGroup } from "../components/UI";

export default function BuergerportalEinstellungen() {
  const [status, setStatus] = useState(null);
  const [neuesPasswort, setNeuesPasswort] = useState("");
  const [meldung, setMeldung] = useState("");

  const laden = () => api.getBuergerportalStatus().then(setStatus);
  useEffect(() => { laden(); }, []);

  if (!status) return <Spinner />;

  const setzen = async () => {
    if (neuesPasswort.trim().length < 6) {
      setMeldung("Mindestens 6 Zeichen erforderlich.");
      return;
    }
    await api.buergerportalPasswortSetzen(neuesPasswort.trim());
    setNeuesPasswort("");
    setMeldung("Zugangscode gespeichert.");
    laden();
  };

  const entfernen = async () => {
    if (!window.confirm("Zugangscode entfernen? Das Bürgerportal wird danach wieder ohne Passwort erreichbar.")) return;
    await api.buergerportalPasswortEntfernen();
    setMeldung("Zugangscode entfernt - Bürgerportal ist wieder offen.");
    laden();
  };

  return (
    <div>
      <div className="page-header">
        <div><div className="breadcrumb">Verwaltung</div><h2>Bürgerportal-Zugang</h2></div>
      </div>
      <div className="content" style={{ maxWidth: 500 }}>
        <div className="card">
          <div className="card-header"><h3>Zugangscode</h3></div>
          <div className="card-body">
            <div style={{ marginBottom: 16, fontSize: 13, color: "var(--ink-soft)" }}>
              Aktueller Status: {status.geschuetzt
                ? <span className="badge badge-durchgefuehrt">Passwortgeschützt</span>
                : <span className="badge badge-abgesagt">Offen (kein Zugangscode)</span>}
            </div>

            {meldung && <div className="alert alert-success">{meldung}</div>}

            <FormGroup label={status.geschuetzt ? "Zugangscode ändern" : "Zugangscode festlegen"}>
              <input className="form-control" type="text" placeholder="Mindestens 6 Zeichen"
                value={neuesPasswort} onChange={e => setNeuesPasswort(e.target.value)} />
            </FormGroup>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="btn btn-primary" onClick={setzen}>Speichern</button>
              {status.geschuetzt && (
                <button className="btn btn-secondary" onClick={entfernen}>Zugangscode entfernen</button>
              )}
            </div>

            <div style={{ fontSize: 11.5, color: "var(--ink-faint)", marginTop: 16 }}>
              Ist ein Zugangscode gesetzt, muss er auf der öffentlichen Bürgerportal-Seite eingegeben werden, bevor Inhalte sichtbar sind. Ohne Zugangscode ist das Portal wie bisher ohne Anmeldung erreichbar.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
